import React, { useState } from 'react'
import Box from '@mui/material/Box';
import { useSelector } from "react-redux";
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import CustomerSummary from './CustomerSummary';
import ConversationSummary from './ConversationSummary';
import { PastTickets } from './PastTickets';


const Summary = ({ subDomain, ticketingSystem, prismToken, ticketId, orgId, agentDetails, userEmail }) => {
  const ticketDetails = useSelector((state) => state.ticket.ticketDetails);
  const [tab, setTab] = useState('Customer Summary');

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "space-between" }}>
      {
        ticketId ?
          <div style={{ display: "flex", flexDirection: "column", height: "100%", width: "100%", gap: "15px" }}>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "10%" }}>
              <ToggleButtonGroup fullWidth color="primary" value={tab} exclusive onChange={(event) => setTab(event.target.value)} >
                <ToggleButton value="Customer Summary" sx={{ fontWeight: "bold" }} >Customer Summary</ToggleButton>
                <ToggleButton value="Conversation Summary" sx={{ fontWeight: "bold" }} >Conversation Summary</ToggleButton>
                <ToggleButton value="Past Tickets" sx={{ fontWeight: "bold" }} >Past Tickets</ToggleButton>
              </ToggleButtonGroup>
            </Box>
            <div style={{ border: "1px solid black", borderRadius: "0.5rem", padding: "1rem", height: "60vh" }}>
              {tab === "Customer Summary" && <CustomerSummary subDomain={subDomain} ticketingSystem={ticketingSystem} ticketDetails={ticketDetails} orgId={orgId} prismToken={prismToken} userEmail={userEmail} />}
              {tab === "Conversation Summary" && <ConversationSummary subDomain={subDomain} ticketingSystem={ticketingSystem} ticketDetails={ticketDetails} orgId={orgId} prismToken={prismToken} userEmail={userEmail} />}
              {tab === "Past Tickets" && <PastTickets subDomain={subDomain} ticketingSystem={ticketingSystem} ticketDetails={ticketDetails} orgId={orgId} prismToken={prismToken} userEmail={userEmail} />}
            </div>
          </div>
          :
          <div></div>
      }
    </div>
  )
}

export default Summary